/**
 * Get the URL for the Admin panel.
 * @returns { string }
 */
export function getAdminUrl() {
  return new URL('/admin', process.env.VUE_APP_API_URL).href;
}
